import selectComponent from 'utilities/select-component'
import Slick from 'vendor/slick';

export default class AutoflameBrandsSlider {

    constructor(element) {
        this.$component = selectComponent(element)
        this.$slider = this.$component.elements.sliderContainer
        
        this.initCarousel()
    }

    initCarousel() {
        this.$slider.slick({
            variableWidth: true,
            slidesToShow: 1,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 4
                    }
                }
            ],
            autoplay: true,
            mobileFirst: true,
        })
    }
}